var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "#3d60d3",
    stroke: "#3d60d3"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    width: 4,
    height: 2,
    x: 6,
    y: 13.94,
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.75,26H22V22H10v4H4.25A3.25,3.25,0,0,1,1,22.75v-9.5A3.25,3.25,0,0,1,4.25,10h23.5A3.25,3.25,0,0,1,31,13.25v9.5A3.25,3.25,0,0,1,27.75,26ZM24,24h3.75A1.25,1.25,0,0,0,29,22.75v-9.5A1.25,1.25,0,0,0,27.75,12H4.25A1.25,1.25,0,0,0,3,13.25v9.5A1.25,1.25,0,0,0,4.25,24H8V21.66A1.66,1.66,0,0,1,9.66,20H22.34A1.66,1.66,0,0,1,24,21.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M21.6 29H10.4A2.4 2.4 0 0 1 8 26.6V21.66A1.66 1.66 0 0 1 9.66 20H22.34A1.66 1.66 0 0 1 24 21.66V26.6A2.4 2.4 0 0 1 21.6 29zM10 22v4.6a.41.41 0 0 0 .4.4H21.6a.41.41 0 0 0 .4-.4V22zM24 12H8V5.4A2.4 2.4 0 0 1 10.4 3H21.6A2.4 2.4 0 0 1 24 5.4zM10 10H22V5.4a.4.4 0 0 0-.4-.4H10.4a.4.4 0 0 0-.4.4z"
  })));
};
export default SvgPrinter;